import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, onMounted, onUnmounted, watch} from 'vue'

  import {useStore} from 'vuex'
  import {useSizable} from '@/lib/sizable'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LazyImage',
  props: {
    src: null,
    alt: null
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    src: string
    alt: string
  };

  const ORIENTATION = {
    PORTRAIT: 'PORTRAIT',
    LANDSCAPE: 'LANDSCAPE'
  }

  const store = useStore()
  const root = ref(null)
  const {width, height} = useSizable(root)

  

  const src = ref(props.src)

  const loading = ref(false)
  const intersected = ref(false)

  let observer = null

  const active = computed(() => {
    return props.src && !loading.value && intersected.value
  })

  const orientationClass = computed(() => {
    const orientation =
      height.value > width.value ? ORIENTATION.PORTRAIT : ORIENTATION.LANDSCAPE

    return `is-${orientation.toLowerCase()}`
  })

  const getData = function () {
    const shouldGetData = intersected.value && props.src

    if (shouldGetData) {
      loading.value = true

      store.dispatch('getImage', props.src).then(() => {
        loading.value = false
      })
    }
  }

  onMounted(() => {
    observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          intersected.value = true
          getData()
          observer.unobserve(root.value)
        }
      })
    })

    observer.observe(root.value)

    getData()
  })

  onUnmounted(() => {
    observer.disconnect()
  })

  watch(src, () => getData())

const __returned__ = { ORIENTATION, store, root, width, height, props, src, loading, intersected, get observer() { return observer }, set observer(v) { observer = v }, active, orientationClass, getData, computed, ref, onMounted, onUnmounted, watch, get useStore() { return useStore }, get useSizable() { return useSizable } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})